import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import "../styles/Treks.css";

const TrekForm = (props) => {
  const [numberOfGuest, setNumberOfGuest] = useState(0);
  const [name, setName] = useState([""]);
  const [age, setAge] = useState([""]);
  const [aadhar, setAadhar] = useState([""]);
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState({
    country: "",
    state: "",
    district: "",
    city: "",
    pincode: "",
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const { title, onClose } = props;
  const navigate = useNavigate();

  const fieldRefs = useRef({});

  const resetForm = () => {
    setNumberOfGuest(0);
    setName([]);
    setAge([]);
    setAadhar([]);
    setMobileNumber("");
    setEmail("");
    setAddress({ country: "", state: "", district: "", city: "", pincode: "" });
  };

  const trekName = "Kagbhusandi Tal Trek";
  const ownerName = "Ishwar Chauhan";
  const wpmessage = `Hello! 👋 Welcome to ${trekName}! I’m ${ownerName}, the organizer. How can I assist you today?`;
  const encodedMessage = encodeURIComponent(wpmessage);

  // Reset form when user navigates away
  useEffect(() => {
    return () => {
      resetForm();
    };
    // eslint-disable-next-line
  }, []);

  const validateFields = () => {
    const newErrors = {};

    if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
      newErrors.mobileNumber = "Enter a valid 10-digit mobile number.";
    } else if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Enter a valid email address.";
    } else if (!address.pincode || !/^\d{6}$/.test(address.pincode)) {
      newErrors.pincode = "Enter a valid 6-digit pincode.";
    } else if (!numberOfGuest || numberOfGuest === 0) {
      newErrors.numberOfGuest = "Enter the number of guests.";
    }

    name.forEach((n, i) => {
      if (!n) newErrors[`name${i}`] = `Enter name for person ${i + 1}.`;
    });
    aadhar.forEach((a, i) => {
      if (!/^\d{12}$/.test(a))
        newErrors[`aadhar${i}`] = `Enter a valid 12-digit Aadhar for person ${
          i + 1
        }.`;
    });
    age.forEach((a, i) => {
      if (!a || a <= 0)
        newErrors[`age${i}`] = `Enter valid age for person ${i + 1}.`;
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const firstInvalidKey = Object.keys(newErrors)[0];
      const invalidField = fieldRefs.current[firstInvalidKey];
      if (invalidField && invalidField.scrollIntoView) {
        invalidField.scrollIntoView({ behavior: "smooth", block: "center" });
        invalidField.focus();
      }
      return false;
    }

    return true;
  };

 const handleGuestChange = (value) => {
  const num = parseInt(value, 10);

  if (value === "" || isNaN(num) || num < 1) {
    setNumberOfGuest(0);
    return;
  }

  const maxGuests = Math.min(num, 10); // Cap at 10

  setNumberOfGuest(maxGuests);
  setName((prev) => [
    ...prev.slice(0, maxGuests),
    ...new Array(Math.max(maxGuests - prev.length, 0)).fill(""),
  ]);
  setAadhar((prev) => [
    ...prev.slice(0, maxGuests),
    ...new Array(Math.max(maxGuests - prev.length, 0)).fill(""),
  ]);
  setAge((prev) => [
    ...prev.slice(0, maxGuests),
    ...new Array(Math.max(maxGuests - prev.length, 0)).fill(""),
  ]);
};

  const handleNameChange = (index, value) => {
    const updateNames = [...name];
    updateNames[index] = value;
    setName(updateNames);
  };

  const handleAgeChange = (index, value) => {
    const updateAges = [...age];
    updateAges[index] = value;
    setAge(updateAges);
  };

  const handleAadharChange = (index, value) => {
    const updateAadhar = [...aadhar];
    updateAadhar[index] = value;
    setAadhar(updateAadhar);
  };

  const handleAddressChange = (field, value) => {
    setAddress((prevAddress) => ({
      ...prevAddress,
      [field]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateFields()) {
      setInProgress(true);
      setShowModal(true);
      const sendResponse = await fetch(
        `${process.env.REACT_APP_URL_SCHEME}${process.env.REACT_APP_IP_ADDRESS}/api/sendtrekdetails`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            trekTitle: title,
            numberOfGuest,
            mobileNumber,
            email,
            address,
            guests: name.map((a, index) => ({
              name: a,
              age: Number(age[index]),
              aadhar: aadhar[index],
            })),
          }),
        }
      );

      const sentEmail = await sendResponse.json();
      setMessage(
        sentEmail.success
          ? `🎉 Booking submitted successfully! We’ll contact you soon.`
          : "Error submitting the form. Check your connection and try again."
      );
      setInProgress(false);
    }
  };

  return (
    <div className="trek-confirm-overlay">
      <h1>{title}</h1>
      <button className="close-bttn" onClick={() => onClose()}>
        &times;
      </button>
      <h3>“The best view comes after the hardest climb.”</h3>
      <div className="main-div">
        <form className="trek-form">
          <label htmlFor="guest">Number of Guests</label>
          <input
            ref={(el) => (fieldRefs.current["numberOfGuest"] = el)}
            type="number"
            id="guest"
            value={numberOfGuest}
            onChange={(e) => handleGuestChange(e.target.value)}
            required
          />
          {errors.numberOfGuest && (
            <p className="error">{errors.numberOfGuest}</p>
          )}

          <label htmlFor="mobile">Mobile Number</label>
          <input
            ref={(el) => (fieldRefs.current["mobileNumber"] = el)}
            type="tel"
            id="mobile"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
            required
          />
          {errors.mobileNumber && (
            <p className="error">{errors.mobileNumber}</p>
          )}

          <label htmlFor="email">Email</label>
          <input
            ref={(el) => (fieldRefs.current["email"] = el)}
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          {errors.email && <p className="error">{errors.email}</p>}

          <label>Address</label>
          <div className="address">
            <label htmlFor="country">Country</label>
            <input
              ref={(el) => (fieldRefs.current["country"] = el)}
              type="text"
              id="country"
              value={address.country}
              onChange={(e) => handleAddressChange("country", e.target.value)}
              required
            />

            <label htmlFor="state">State</label>
            <input
              ref={(el) => (fieldRefs.current["state"] = el)}
              type="text"
              id="state"
              value={address.state}
              onChange={(e) => handleAddressChange("state", e.target.value)}
              required
            />

            <label htmlFor="district">District</label>
            <input
              ref={(el) => (fieldRefs.current["district"] = el)}
              type="text"
              id="district"
              value={address.district}
              onChange={(e) => handleAddressChange("district", e.target.value)}
              required
            />

            <label htmlFor="city">City</label>
            <input
              ref={(el) => (fieldRefs.current["city"] = el)}
              type="text"
              id="city"
              value={address.city}
              onChange={(e) => handleAddressChange("city", e.target.value)}
              required
            />

            <label htmlFor="pincode">Pincode</label>
            <input
              ref={(el) => (fieldRefs.current["pincode"] = el)}
              type="tel"
              id="pincode"
              value={address.pincode}
              onChange={(e) => handleAddressChange("pincode", e.target.value)}
              required
            />
            {errors.pincode && <p className="error">{errors.pincode}</p>}
          </div>

          {Array.from({ length: numberOfGuest }, (_, index) => (
            <div className="form" key={`guest-${index}`}>
              <label htmlFor={`name-${index}`}>
                Name of Person {index + 1}
              </label>
              <input
                ref={(el) => (fieldRefs.current[`name${index}`] = el)}
                type="text"
                id={`name-${index}`}
                value={name[index] || ""}
                onChange={(e) => handleNameChange(index, e.target.value)}
                required
              />
              {errors[`name${index}`] && (
                <p className="error">{errors[`name${index}`]}</p>
              )}

              <label htmlFor={`age-${index}`}>Age</label>
              <input
                ref={(el) => (fieldRefs.current[`age${index}`] = el)}
                type="tel"
                id={`age-${index}`}
                value={age[index] || ""}
                onChange={(e) => handleAgeChange(index, e.target.value)}
                required
              />
              {errors[`age${index}`] && (
                <p className="error">{errors[`age${index}`]}</p>
              )}

              <label htmlFor={`aadhar-${index}`}>Aadhar Number</label>
              <input
                ref={(el) => (fieldRefs.current[`aadhar${index}`] = el)}
                type="number"
                id={`aadhar-${index}`}
                value={aadhar[index] || ""}
                onChange={(e) => handleAadharChange(index, e.target.value)}
                required
              />
              {errors[`aadhar${index}`] && (
                <p className="error">{errors[`aadhar${index}`]}</p>
              )}
            </div>
          ))}
          <button className="submit-btn" type="submit" onClick={handleSubmit}>Submit</button>
        </form>
      </div>
      {showModal && (
        <div className="trek-modal">
          <div className="trek-modal-content">
            <button
              className="close-bttn"
              onClick={() => {
                setShowModal(false);
                resetForm();
                setInProgress(false);
                navigate("/");
              }}
            >
              &times;
            </button>
            {inProgress ? (
              <div className="loading-container">
                <h5>
                  Submitting your details... Please wait<br />
                </h5>
                <div className="spinner"></div>
              </div>
            ) : (
              <div>
                <h5>{message} <br/>
                Or <br />
                You can contact </h5>
               <a
                  href={`https://wa.me/918273483585?text=${encodedMessage}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="connect-item whatsapp"
                >
                  <FaWhatsapp size={24} />
                </a>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TrekForm;
